export default {
  methods: {

    set_LocalValues(){
      
      this.rawData = JSON.parse(JSON.stringify(this.DataItems))
      this.cutoff = JSON.parse(JSON.stringify(this.Queries.SQL1[0])).CUTOFF
      this.cutoff1 = JSON.parse(JSON.stringify(this.Queries.SQL1[0])).CUTOFF1
      this.updated = JSON.parse(JSON.stringify(this.Queries.SQL1[0])).NAME

      this.rawData.forEach(d=> {
        d.STATUS = 'NOT'
        if(d.MCC_TOT>0 && d.MCC_REM==0) d.STATUS = 'MCC'
        if(d.PCC_A)   d.STATUS = 'PCC'
      })

      this.setData = this.rawData
      let json = JSON.parse(JSON.stringify(this.JQueries))

      this.revision   = json.revision
      this.system     = json.system
      this.status     = json.status
      this.handover   = json.handover
      this.innerSVG   = json.innerSVG
      this.search     = json.search
      this.donuts     = json.donuts

      this.sundries   = json.sundries
      this.sundries2   = json.sundries2
      this.keys       = json.keys
      this.filters    = json.filters

      this.Boundary = this.Boundary + `${this.revision}/`

      this.current = {
        status:'OVERALL',
        handover: 'OVERALL',
        sys: null,
        list: 'JPG',
        page: 1,
        mouseover: null,
        tab: 'OVERALL'
      }
      // for Exporting PDF file
      if (this.getSelectItems) {
        this.getItems = JSON.parse(this.getSelectItems)
        if (this.getItems.current) {
          this.current = this.getItems.current
          this.pdfDrawing = true
        }
      }
      this.filteringData()

    },



    filteringData() {

      // Status
      this.status.forEach(d=> {
        if(d.code == 'OVERALL') {
          d.count = this.rawData.length
        } else {
          d.count = this.rawData.filter(f=> f.STATUS == d.code).length
        }
      })

      if(this.current.status == 'OVERALL') this.setData = this.rawData
      else this.setData = this.rawData.filter(f=> f.STATUS == this.current.status)
      
      // Handover
      this.handover.forEach(d=> {
        if(d.code =='OVERALL') d.count = this.setData.length
        else d.count = this.setData.filter(f=> f.SYS_CODE == d.code).length
      })
      
      if(this.current.handover == 'OVERALL') this.setData = this.setData
      else this.setData = this.setData.filter(f=> f.SYS_CODE == this.current.handover)
      



      // Search
      if(this.search.input) {
        this.setData = this.setData.filter(f =>
          f.SYS.toLowerCase().includes(this.search.input.toLowerCase()) ||
          f.DESC.toLowerCase().includes(this.search.input.toLowerCase())
        )

        // Change the page index to 1 (if it is not 1, nothing can be displayed)
        this.current.page = 1
      }
      
      
    },

  }
}